/* ============================================================
   Bellem Quick View
   Vanilla JS — no dependencies.
   Fetches product data via Shopify AJAX API /{handle}.js
   ============================================================ */
(function () {
  'use strict';

  var overlay   = document.getElementById('bellem-quick-view');
  if (!overlay) return;
  if (overlay.dataset.qvInit) return; // prevent duplicate initialisation if script loads twice
  overlay.dataset.qvInit = '1';

  var modal     = overlay.querySelector('.qv-modal');
  var closeBtn  = overlay.querySelector('.qv-close');
  var track     = overlay.querySelector('.qv-gallery__track');
  var dotsWrap  = overlay.querySelector('.qv-gallery__dots');
  var prevBtn   = overlay.querySelector('.qv-gallery__arrow--prev');
  var nextBtn   = overlay.querySelector('.qv-gallery__arrow--next');
  var titleEl   = overlay.querySelector('.qv-title');
  var priceEl   = overlay.querySelector('.qv-price');
  var sizeLabelEl = overlay.querySelector('.qv-size-label');
  var sizesWrap = overlay.querySelector('.qv-sizes');
  var atcBtn    = overlay.querySelector('.qv-atc');
  var viewFull  = overlay.querySelector('.qv-view-full');

  var currentVariantId = null;
  var currentProduct   = null;
  var galleryIndex     = 0;
  var galleryTotal     = 0;
  var touchStartX      = 0;

  /* ── Money formatter ─────────────────────────────────────── */
  function formatMoney(cents) {
    var fmt = overlay.dataset.moneyFormat || '${{amount}}';
    var amount      = (cents / 100).toFixed(2);
    var amountNoDec = String(Math.floor(cents / 100));
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g,                        amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g,            amountNoDec)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g,   amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g,
               amountNoDec.replace(/\B(?=(\d{3})+(?!\d))/g, ','));
  }

  /* ── Shopify CDN size param ──────────────────────────────── */
  function cdnSize(url, width) {
    if (!url) return url;
    var sep = url.indexOf('?') >= 0 ? '&' : '?';
    return url + sep + 'width=' + width;
  }

  /* ── Open / close ────────────────────────────────────────── */
  function openModal() {
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Focus the close button after transition
    setTimeout(function () { closeBtn.focus(); }, 50);
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ── Gallery ─────────────────────────────────────────────── */
  function goToSlide(index) {
    if (galleryTotal === 0) return;
    galleryIndex = (index + galleryTotal) % galleryTotal;
    track.style.transform = 'translateX(' + (-galleryIndex * 100) + '%)';

    var dots = dotsWrap.querySelectorAll('.qv-gallery__dot');
    dots.forEach(function (dot, i) {
      dot.classList.toggle('is-active', i === galleryIndex);
    });
  }

  function showGalleryArrows(show) {
    prevBtn.style.display = show ? '' : 'none';
    nextBtn.style.display = show ? '' : 'none';
  }

  prevBtn.addEventListener('click', function () {
    goToSlide(galleryIndex - 1);
  });

  nextBtn.addEventListener('click', function () {
    goToSlide(galleryIndex + 1);
  });

  // Touch swipe
  track.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  track.addEventListener('touchend', function (e) {
    var diff = touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      goToSlide(diff > 0 ? galleryIndex + 1 : galleryIndex - 1);
    }
  }, { passive: true });

  /* ── Render ──────────────────────────────────────────────── */
  function renderProduct(product, productUrl) {
    currentProduct = product;

    titleEl.textContent = product.title;
    viewFull.href = productUrl || ('/' + product.handle);

    // Price — only show compare-at if it's genuinely higher
    var price        = product.price_min;
    var comparePrice = product.compare_at_price_min;
    if (comparePrice && comparePrice > price) {
      priceEl.innerHTML =
        formatMoney(price) +
        '<span class="qv-price__compare">' + formatMoney(comparePrice) + '</span>';
    } else {
      priceEl.textContent = formatMoney(price);
    }

    // Gallery — first 2 images
    // product.images may contain URL strings or objects with a .src property
    track.innerHTML  = '';
    dotsWrap.innerHTML = '';
    var rawImages = (product.images && product.images.length)
      ? product.images.slice(0, 2)
      : (product.featured_image ? [product.featured_image] : []);
    var images = rawImages.map(function (img) {
      return typeof img === 'string' ? img : (img.src || '');
    }).filter(Boolean);
    galleryTotal = images.length;

    images.forEach(function (imgSrc, i) {
      var slide = document.createElement('div');
      slide.className = 'qv-gallery__slide';

      var img = document.createElement('img');
      img.src     = cdnSize(imgSrc, 800);
      img.alt     = product.title;
      img.loading = 'lazy';
      slide.appendChild(img);
      track.appendChild(slide);

      if (images.length > 1) {
        var dot = document.createElement('button');
        dot.type      = 'button';
        dot.className = 'qv-gallery__dot' + (i === 0 ? ' is-active' : '');
        dot.setAttribute('aria-label', 'Image ' + (i + 1));
        (function (idx) {
          dot.addEventListener('click', function () { goToSlide(idx); });
        })(i);
        dotsWrap.appendChild(dot);
      }
    });

    showGalleryArrows(galleryTotal > 1);
    goToSlide(0);

    // Size / variant selector
    renderSizes(product);
  }

  function renderSizes(product) {
    sizesWrap.innerHTML = '';
    currentVariantId = null;

    // Normalise options — Shopify returns strings OR objects {name, values, ...}
    var optionNames = (product.options || []).map(function (opt) {
      return typeof opt === 'string' ? opt : (opt.name || '');
    });

    // Find the "Size" option (or single non-title option)
    var sizeOptionIndex = -1;
    optionNames.forEach(function (name, i) {
      if (name.toLowerCase() === 'size') sizeOptionIndex = i;
    });
    if (sizeOptionIndex < 0 && optionNames.length === 1 &&
        optionNames[0].toLowerCase() !== 'title') {
      sizeOptionIndex = 0;
    }

    if (sizeOptionIndex >= 0) {
      sizeLabelEl.style.display = '';
      sizeLabelEl.querySelector('.qv-size-label__name').textContent =
        optionNames[sizeOptionIndex];

      // Collect unique size values preserving variant availability
      var seen   = {};
      var values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (sizeOptionIndex + 1)];
        if (!seen[val]) {
          seen[val] = true;
          values.push({ value: val, available: v.available, id: v.id });
        } else if (v.available) {
          // If a later variant with same size is available, mark it so
          for (var j = 0; j < values.length; j++) {
            if (values[j].value === val) { values[j].available = true; break; }
          }
        }
      });

      var firstAvailable = null;
      values.forEach(function (size, i) {
        var uid     = 'qv-size-' + product.id + '-' + i;
        var input   = document.createElement('input');
        input.type  = 'radio';
        input.name  = 'qv-size-' + product.id;
        input.id    = uid;
        input.value = size.id;
        input.className = 'qv-size__input';
        if (!size.available) input.disabled = true;
        if (!firstAvailable && size.available) {
          firstAvailable = size;
          input.checked  = true;
          currentVariantId = size.id;
        }

        var label = document.createElement('label');
        label.setAttribute('for', uid);
        label.className = 'qv-size__label' +
          (!size.available ? ' qv-size__label--sold-out' : '');
        label.textContent = size.value;

        input.addEventListener('change', function () {
          if (this.checked) {
            currentVariantId = parseInt(this.value, 10);
            updateAtcState();
          }
        });

        sizesWrap.appendChild(input);
        sizesWrap.appendChild(label);
      });
    } else {
      // No meaningful option — use first available variant silently
      sizeLabelEl.style.display = 'none';
      var firstAvailVariant = null;
      for (var k = 0; k < product.variants.length; k++) {
        if (product.variants[k].available) {
          firstAvailVariant = product.variants[k];
          break;
        }
      }
      currentVariantId = firstAvailVariant
        ? firstAvailVariant.id
        : product.variants[0].id;
    }

    updateAtcState();
  }

  function updateAtcState() {
    if (!currentVariantId) {
      atcBtn.textContent = 'Select a Size';
      atcBtn.disabled    = true;
      return;
    }
    var variant = null;
    if (currentProduct) {
      for (var i = 0; i < currentProduct.variants.length; i++) {
        if (currentProduct.variants[i].id === currentVariantId) {
          variant = currentProduct.variants[i];
          break;
        }
      }
    }
    if (!variant || !variant.available) {
      atcBtn.textContent = 'Sold Out';
      atcBtn.disabled    = true;
    } else {
      atcBtn.textContent = 'Add to Cart';
      atcBtn.disabled    = false;
    }
  }

  /* ── Add to Cart ─────────────────────────────────────────── */
  atcBtn.addEventListener('click', function () {
    if (!currentVariantId || atcBtn.disabled) return;

    atcBtn.classList.add('qv-atc--loading');
    atcBtn.disabled    = true;
    atcBtn.textContent = 'Adding\u2026';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type':    'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: currentVariantId, quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart/add failed: ' + res.status);
      return res.json();
    })
    .then(function () {
      atcBtn.classList.remove('qv-atc--loading');
      atcBtn.textContent = 'Added!';

      setTimeout(function () {
        closeModal();
        // Notify any cart drawer / cart count listeners
        document.dispatchEvent(new CustomEvent('bellem:cart:updated', { bubbles: true }));
      }, 700);
    })
    .catch(function () {
      atcBtn.classList.remove('qv-atc--loading');
      atcBtn.disabled    = false;
      atcBtn.textContent = 'Error — Try Again';
      setTimeout(function () {
        atcBtn.textContent = 'Add to Cart';
      }, 2200);
    });
  });

  /* ── Trigger: Quick Add buttons ──────────────────────────── */
  document.querySelectorAll('.product-card__quick-add').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const handle = this.getAttribute('data-handle');
      console.log('1. Button clicked. Handle grabbed:', handle);

      if (!handle) {
        console.error('Error: No handle found on button.');
        return;
      }

      var shopifyRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const fetchUrl = shopifyRoot + 'products/' + handle + '.js';
      console.log('2. Attempting to fetch from:', fetchUrl);

      var productUrl = this.getAttribute('data-url');

      // Reset to loading state — purge any stale error nodes first
      overlay.querySelectorAll('.qv-error').forEach(function (el) { el.remove(); });
      titleEl.textContent   = '';
      priceEl.textContent   = '';
      sizesWrap.innerHTML   = '';
      dotsWrap.innerHTML    = '';
      track.innerHTML       = '<div class="qv-loading">Loading\u2026</div>';
      currentVariantId      = null;
      currentProduct        = null;
      atcBtn.textContent    = 'Add to Cart';
      atcBtn.disabled       = false;
      viewFull.href         = productUrl || '#';
      sizeLabelEl.style.display = 'none';
      showGalleryArrows(false);
      goToSlide(0);

      openModal();

      fetchProduct(fetchUrl, productUrl);
    });
  });

  function fetchProduct(fetchUrl, productUrl) {
    fetch(fetchUrl)
      .then(function (res) {
        console.log('[Bellem QV] Response status:', res.status, res.url);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (text) {
        try {
          return JSON.parse(text);
        } catch (e) {
          console.error('[Bellem QV] JSON parse failed. First 300 chars:', text.slice(0, 300));
          throw new Error('Response was not JSON — store may be password protected');
        }
      })
      .then(function (product) {
        renderProduct(product, productUrl);
      })
      .catch(function (err) {
        console.error('[Bellem QV] Fetch failed:', err.message);
        showFetchError(fetchUrl, err.message, productUrl);
      });
  }

  function showFetchError(fetchUrl, errorMsg, productUrl) {
    // Remove any previously injected error node before creating a new one
    overlay.querySelectorAll('.qv-error').forEach(function (el) { el.remove(); });

    track.innerHTML = '';
    titleEl.textContent = '';
    priceEl.textContent = '';
    sizesWrap.innerHTML = '';
    sizeLabelEl.style.display = 'none';
    atcBtn.disabled = true;
    atcBtn.textContent = 'Add to Cart';

    var wrap = document.createElement('div');
    wrap.className = 'qv-error';
    // Show the URL and error visibly so it can be read without DevTools
    wrap.innerHTML =
      '<p class="qv-error__msg">Item Unavailable</p>' +
      '<p class="qv-error__debug">URL: ' + fetchUrl + '</p>' +
      '<p class="qv-error__debug">Reason: ' + (errorMsg || 'unknown') + '</p>' +
      '<button class="qv-error__retry" type="button">Retry</button>';

    wrap.querySelector('.qv-error__retry').addEventListener('click', function () {
      wrap.remove();
      track.innerHTML = '<div class="qv-loading">Loading\u2026</div>';
      atcBtn.disabled = false;
      fetchProduct(fetchUrl, productUrl);
    });

    var infoPanel = overlay.querySelector('.qv-info');
    infoPanel.insertBefore(wrap, infoPanel.firstChild);
  }

  /* ── Close triggers ──────────────────────────────────────── */
  closeBtn.addEventListener('click', closeModal);

  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  /* ── Focus trap ──────────────────────────────────────────── */
  modal.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(modal.querySelectorAll(
      'button:not([disabled]), input:not([disabled]), a[href], [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      return el.offsetParent !== null; // visible only
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });

})();
